import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { AlertNotificactions, AlertNotificactionsCount } from '../interface/headers.interface';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { Router } from '@angular/router';

@Component({
  selector: 'app-alert-notification',
  templateUrl: './alert-notification.component.html',
  standalone: true,
  imports: [MatDividerModule, MatListModule, CommonModule, MaterialModule],
  styleUrls: ['./alert-notification.component.scss'],
})
export class AlertNotificationComponent {
  @Output() closeNotifications: EventEmitter<void> = new EventEmitter<void>()
  @Output() contentSucceed: EventEmitter<void> = new EventEmitter<void>()
  @Output() moreNotify: EventEmitter<void> = new EventEmitter<void>()
  @Input() notificationsRecived!: AlertNotificactions[];
  @Input() notificationsRecivedCountPending!: AlertNotificactionsCount;
  private clickListener!: () => void;
  private ignoreFirstClick: boolean = true;
  public alerts: AlertNotificactions[];
  public alertsMinute: AlertNotificactions[] = [];
  public alertsDiscount: AlertNotificactions[] = [];
  public permission: string[];
  public permissionNotificationCuotes: boolean = false;
  public permissionNotificationMinutes: boolean = false;

  constructor(private elementRef: ElementRef, private notification: NotificationsService, private auth: AuthService, private router: Router) {
    this.auth.getEmailIdentifier();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notificationsRecived']) {
      const currentNotifications = changes['notificationsRecived'].currentValue;
      this.categorizeNotification(currentNotifications);
    }
  }

  ngOnInit(): void {
    this.clickListener = this.onDocumentClick.bind(this);
    document.addEventListener('click', this.clickListener);
    this.categorizeNotification(this.notificationsRecived);
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.clickListener);
  }

  onDocumentClick(event: MouseEvent): void {
    if (this.ignoreFirstClick) {
      this.ignoreFirstClick = false;
      return;
    }
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.onClickOutside();
    }
  }

  onClickOutside(): void {
    this.closeNotifications.emit();
  }

  categorizeNotification(notificaciones: AlertNotificactions[]) {
    this.alerts = this.notificationsRecived;
    this.alertsMinute = notificaciones.filter((notification) => notification.type === 1);
    this.alertsDiscount = notificaciones.filter((notification) => notification.type === 2);
    this.contentSucceed.emit();
  }

  redirectDiscount(alertDiscount: AlertNotificactions) {
    this.onClickOutside();
    this.router.navigateByUrl(`dashboards/simulations/${alertDiscount.idType}`);
  }

  redirectMinute(alertMinute: AlertNotificactions) {
    this.onClickOutside();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`dashboards/minute`], { queryParams: { id: alertMinute.idType } });
    });
  }

  public loadMoreMinutes(): void {
    this.moreNotify.emit();
  }

  public permisonViewNotification(permiso: string): boolean {
    const permissionsUsers = this.auth.getUserPermissions();
    const a = permissionsUsers.filter((e) => 
      e.includes(permiso)
    ).map((e) => e);
    return a.length > 0;
  }

}